import { CreateResidencyJurisdictionRequest } from '../../../../web-api-client';
import { ResidencyJurisdiction } from '../../models';

export const mapResidencyJurisdictionToCreateRequest = (
  residencyJurisdiction: ResidencyJurisdiction
): CreateResidencyJurisdictionRequest => {
  return new CreateResidencyJurisdictionRequest({
    countryId: residencyJurisdiction.country!.countryId!,
    isActive: residencyJurisdiction.isActive,
  });
};
